import { useMutation } from '@tanstack/react-query';
import { GET, GET_WARRANTY_NUMBER_CODE } from '../../../services';
import { openAlert } from '../../../components/alert/hooks';

export const useGetWarrantyNumberCode = () => {
  return useMutation({
    mutationFn: async (value) => {
      const response = await GET(GET_WARRANTY_NUMBER_CODE(value));
      return response;
    },
    onSuccess: (data) => {
      openAlert({
        model: 'message',
        message: data?.message,
        type: 'success',
      });
    },
    onError: (error) => {
      openAlert({
        model: 'message',
        message: error?.message,
        type: 'error',
      });
    },
  });
};
